import { useEffect, useRef, useState } from "react";
import { Camera } from "lucide-react";
import { api, errMsg, fmt } from "../lib/api";
import Scanner from "./Scanner";

export const specLine = (g) => `${g.spesifikasi} • ${g.dimensi} • P ${g.panjang}${g.grade ? " • " + g.grade : ""}${g.tebal ? " • Tebal " + g.tebal + "mm" : ""}`;

export default function MaterialSearch({ onSelect, inStock = false, placeholder, testid = "material-search", initialQuery = "" }) {
  const [q, setQ] = useState(initialQuery);
  useEffect(() => { if (initialQuery) setQ(initialQuery); }, [initialQuery]);
  const [res, setRes] = useState([]);
  const [open, setOpen] = useState(false);
  const [status, setStatus] = useState("");
  const [scan, setScan] = useState(false);
  const [openBase, setOpenBase] = useState("");
  const seq = useRef(0);

  useEffect(() => {
    if (q.trim().length < 2) { setRes([]); setStatus(""); return; }
    const id = ++seq.current;
    const t = setTimeout(async () => {
      setStatus("Mencari... / 搜索中...");
      try {
        const r = await api.get("/master/search", { params: { q, in_stock: inStock } });
        if (id !== seq.current) return;
        setRes(r.data.results);
        setOpen(true);
        setStatus(`${r.data.results.length} material ditemukan / 找到物料`);
      } catch (e) { setStatus(errMsg(e)); }
    }, 250);
    return () => clearTimeout(t);
  }, [q, inStock]);

  const pick = (g) => { setOpen(false); setQ(""); onSelect(g); };
  const onScan = (text) => {
    setScan(false);
    const m = text.match(/MAT-\d{6}-\d{4}/i);
    setQ(m ? m[0].toUpperCase() : text);
  };

  return (
    <div className="outbound-smart-search-wrap">
      <div className="barcode-row">
        <div className="outbound-smart-search">
          <input value={q} onChange={(e) => setQ(e.target.value)} onFocus={() => res.length && setOpen(true)}
            placeholder={placeholder || "KETIK PLAT, HOLLOW, WF, BARCODE ID ATAU KODE MATERIAL"} data-testid={`${testid}-input`} />
          {open && res.length > 0 && (
            <div className="outbound-search-suggestions" data-testid={`${testid}-results`}>
              <div className="outbound-suggestion-section">Master Material / 物料主数据</div>
              {groupBase(res).map((grp) => grp.items.length > 1 ? (
                <div key={grp.base} className="outbound-suggestion-group" data-testid={`${testid}-group-${grp.base}`}>
                  <button type="button" className="outbound-suggestion-item group-head" onClick={() => setOpenBase(openBase === grp.base ? "" : grp.base)} data-testid={`${testid}-group-toggle-${grp.base}`}>
                    <span><span className="outbound-suggestion-code">{grp.base}</span><span className="outbound-suggestion-detail">{grp.items.length} tebal berbeda / 不同厚度: {grp.items.map((x) => `T${x.tebal || "-"}`).join(", ")} {openBase === grp.base ? "▾" : "›"}</span></span>
                    <span className="outbound-suggestion-stock">{fmt(grp.total)} {grp.items[0].satuan}</span>
                  </button>
                  {openBase === grp.base && grp.items.map((g) => <button type="button" key={g.material_code} className="outbound-suggestion-item sub" onClick={() => pick(g)} data-testid={`${testid}-item-${g.material_code}`}><span><span className="outbound-suggestion-code">{g.material_code}</span><span className="outbound-suggestion-detail">Tebal {g.tebal || "-"} mm • {g.grade || ""} • {g.rows.length} Barcode/Area</span></span><span className="outbound-suggestion-stock">{fmt(g.available_qty)} {g.satuan}</span></button>)}
                </div>
              ) : grp.items.map((g) => (
                <button type="button" key={g.material_code} className="outbound-suggestion-item" onClick={() => pick(g)} data-testid={`${testid}-item-${g.material_code}`}>
                  <span>
                    <span className="outbound-suggestion-code">{g.material_code}</span>
                    <span className="outbound-suggestion-detail">{g.kategori} • {specLine(g)} • {g.rows.length} Barcode/Area</span>
                  </span>
                  <span className="outbound-suggestion-stock">{fmt(g.available_qty)} {g.satuan}</span>
                </button>
              )))}
              <div className="outbound-search-footer">Stok di daftar = referensi indeks; stok LIVE dicek ulang saat simpan / 列表库存仅供参考</div>
            </div>
          )}
        </div>
        <button type="button" className="scan-btn" onClick={() => setScan(true)} data-testid={`${testid}-camera-btn`}><Camera size={22} /></button>
      </div>
      <small className="outbound-search-status" data-testid={`${testid}-status`}>{status}</small>
      {scan && <Scanner onResult={onScan} onClose={() => setScan(false)} />}
    </div>
  );
}

function groupBase(res) {
  const m = new Map();
  res.forEach((g) => { const b = g.base_code || g.material_code; if (!m.has(b)) m.set(b, { base: b, items: [], total: 0 }); const x = m.get(b); x.items.push(g); x.total += g.available_qty; });
  return [...m.values()];
}
